<template>
    <custom-table
        :title="$t('pages.ecommerce.promotion.title')"
        :subTitle="$t('pages.ecommerce.promotion.subTitle')"
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        selectableRows
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        changeUrlPage
        filterComponentName="UserFilter"
        @action="handleClickAction"
        @selectableRows="handleSelectedRow"
        @changeTable="handleTableChange"
    >
        <template v-slot:discount_value="{ row: record }">
            {{ record.discount_type_id === 1 ? `%${record.discount_value}` : `${record.discount_value} ${record.currency.code}` }}
        </template>
        <template v-slot:usage="{ row: record }">
            {{ record.used_count }}/{{ record.max_usage_count ?? '&infin;' }}
        </template>
        <template v-slot:starts_at="{ row: record }">
            {{ record.starts_at ? $moment(record.starts_at).format("DD.MM.YYYY - HH:mm") : "-" }}
        </template>
        <template v-slot:expires_at="{ row: record }">
            {{ record.expires_at ? $moment(record.expires_at).format("DD.MM.YYYY - HH:mm") : "-" }}
        </template>
        <template v-slot:active="{ row: record }">
            <span :class="record.active ? 'badge-light-success': 'badge-light-danger'" class="badge">{{ record.active ? $t('common.active') : $t('common.passive') }}</span>
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <el-tooltip :content="$t('common.edit')" placement="top">
                    <router-link :to="'/ecommerce/promotion/save/' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                     <span class="svg-icon svg-icon-3">
                         <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                     </span>
                    </router-link>
                </el-tooltip>
                <a @click="deleteRecord([record.id])" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                    <span class="svg-icon svg-icon-3">
                        <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                    </span>
                </a>
            </div>
        </template>
    </custom-table>
</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "user",
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("pages.ecommerce.promotion.cols.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.ecommerce.promotion.cols.code"),
                    key: "code",
                    class: ""
                },
                {
                    name: this.$t("pages.ecommerce.promotion.cols.discount_value"),
                    scopedSlots: {customRender: "discount_value"}
                },
                {
                    name: this.$t("pages.ecommerce.promotion.cols.usage"),
                    scopedSlots: {customRender: "usage"}
                },
                {
                    name: this.$t("pages.ecommerce.promotion.cols.starts_at"),
                    scopedSlots: {customRender: "starts_at"}
                },
                {
                    name: this.$t("pages.ecommerce.promotion.cols.expires_at"),
                    scopedSlots: {customRender: "expires_at"}
                },
                {
                    name: this.$t("pages.ecommerce.promotion.cols.active"),
                    scopedSlots: {customRender: "active"}
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            selectedRowKeys: [],
            filterParameters: {},
            exportLoading: false
        }
    },
    computed: {
        table() {
            return this.$store.state.ecommerce.promotion.table;
        },
        userID() {
            return this.$route.query.userID;
        }
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("menu.promotionList"), []);

        this.filterParameters = {
            sort: 'created_at:desc'
        };

        this.$store.dispatch('ecommerce/promotion/get', {
            page: {
                current: this.$route.query.page
            },
            filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
        });
    },
    methods: {
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                case "new":
                    this.$router.push({
                        path: "/ecommerce/promotion/save"
                    });
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },
        refreshTable() {
            this.$store.dispatch('ecommerce/promotion/get', {
                page: {
                    current: this.$route.query.page
                },
                filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
            });
        },
        handleTableChange(pagination, filterData) {
            this.filterParameters = Object.assign({
                sort: 'created_at:desc',
            }, filterData);

            this.$store.dispatch("ecommerce/promotion/get", {
                page: pagination,
                filterData: this.filterParameters
            });
        },
        handleSelectedRow(record) {
            this.selectedRowKeys = record;
        },
        deleteRecord(id) {
            this.eventBus.$emit('showConfirmDialog', {
                title: this.$t('btn.delete'),
                message: this.$t('messages.sureDelete'),
                confirmType: 'danger',
                onConfirm: () => {
                    this.$store.dispatch("ecommerce/promotion/delete", {id}).then((successDeleted) => {
                        this.selectedRowKeys = this.selectedRowKeys.filter(x => !successDeleted.includes(x));
                        this.refreshTable();
                    });
                },
            });
        },
    }
}
</script>

<style scoped>

</style>